"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonText = exports.StyledButton = void 0;
const building_blocks_ui_typography_1 = require("@acko-tech/building-blocks.ui.typography");
const styled_components_1 = __importDefault(require("styled-components"));
var paddingSizeEnum;
(function (paddingSizeEnum) {
    paddingSizeEnum["large"] = "11px 0px";
    paddingSizeEnum["medium"] = "7px 0px";
    paddingSizeEnum["small"] = "5px 0px";
    // 1px disperency in extra small due to animation height
    paddingSizeEnum["extra-small"] = "4px 0px";
    paddingSizeEnum["undefined"] = "11px 0px";
})(paddingSizeEnum || (paddingSizeEnum = {}));
exports.StyledButton = styled_components_1.default.button `
  cursor: pointer;
  width: 100%;
  align-items: center;
  // adding padding due to loading button size disperency
  padding: ${(props) => !props.loading ? props.theme.spacing[2] + ' ' + props.theme.spacing[4] : paddingSizeEnum[props.className]};
  border-radius: ${(props) => props.theme.border.radius.large};
  font-weight: ${(props) => props.theme.typography.fonts.weight.T4_SB};
  line-height: ${(props) => props.theme.typography.lineHeights.H3};
  font-size: ${(props) => props.theme.typography.fonts.size.P1};
  font-family: inherit;
  &.large {
    ${(props) => (props.isFullWidth ? '' : 'max-width: 117px')};
    line-height: ${(props) => props.theme.typography.lineHeights.H3};
    font-size: ${(props) => props.theme.typography.fonts.size.P1};
  }
  &.medium {
    ${(props) => (props.isFullWidth ? '' : 'max-width: 107px')};
    line-height: ${(props) => props.theme.typography.lineHeights.T2};
    font-size: ${(props) => props.theme.typography.fonts.size.T4_SB};
  }
  &.small {
    ${(props) => (props.isFullWidth ? '' : 'max-width: 107px')};
    line-height: ${(props) => props.theme.typography.lineHeights.T4_SB};
    font-size: ${(props) => props.theme.typography.fonts.size.T4_SB};
  }
  &.extra-small {
    ${(props) => (props.isFullWidth ? '' : 'max-width: 107px')};
    /* TODO - line height 14px doesn't exist in style guides - putting 16px here */
    line-height: ${(props) => props.theme.typography.lineHeights.C1};
    font-size: ${(props) => props.theme.typography.fonts.size.T4_SB};
  }
`;
exports.ButtonText = (0, styled_components_1.default)(building_blocks_ui_typography_1.Text) `
    color: #ffffff;
    font-weight: 500;
    font-size: height: ${props => (props.fontSize ? props.fontSize : '16px')};
    line-height: 18px;
`;
//# sourceMappingURL=button.js.map